<template>
  <b-form @submit.prevent="formSubmitted">
    <div class="d-flex justify-content-center mb-1" v-if="mainLoading">
      <b-spinner
        variant="success"
        label="Spinning"
        block
        style="width: 3rem; height: 3rem"
      ></b-spinner>
    </div>
    <b-row v-if="!mainLoading">
      <b-col md="6">
        <b-form-group label="Campaign Id" label-for="campaign_id">
          <b-form-input
            placeholder="Campaign Id"
            readonly
            v-model="emailId.id"
            name="campaign_id"
          />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label="Campaign Name" label-for="campaign_name">
          <b-form-input
            placeholder="Campaign Name"
            name="campaign_name"
            v-model="emailId.name"
            readonly
          />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label="Start Date" label-for="start_date">
          <b-form-datepicker
            v-model="emailId.startDate"
            id="start_date"
            placeholder="Choose a date"
            local="en"
            disabled
          />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label="End Date" label-for="end_date">
          <b-form-datepicker
            v-model="emailId.endDate"
            id="end_date"
            placeholder="Choose a date"
            local="en"
            initial-date="2024-06-16"
            disabled
          />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label="Email Template" label-for="email_template">
          <b-form-select
            v-model="emailId.emailTemplate.templateId"
            :options="emailtemplatelist"
            disabled
          /> </b-form-group
      ></b-col>
      <b-col md="6">
        <b-form-group label="Subject" label-for="subject">
          <b-form-input
            placeholder="Subject"
            name="subject"
            v-model="emailId.emailTemplate.subject"
            readonly
          />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label="Segment" label-for="segment">
          <v-select
            v-model="selectedSegments"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            multiple
            label="itemTitle"
            :options="segmentOptions"
            disabled
          /> </b-form-group
      ></b-col>
      <b-col md="6">
        <b-form-group label="Status" label-for="status">
          <b-form-select
                v-model="emailId.status"
                :options="statusOptions"
                disabled
              /> </b-form-group
      ></b-col>

      <b-col md="6">
          <b-form-group label="SMTP Setting" label-for="email_smtp">
            <validation-provider
              rules="required"
              #default="{ errors }"
              name="SMPT setting"
              vid="SMPT Setting"
            >
              <b-form-select
                v-model="emailId.smtpSettingId"
                :state="errors.length > 0 ? false : null"
                :options="smtp"
                disabled
              />

              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="6" v-if="emailId.status === 'SCHEDULED'">
        <b-form-group label="Scheduled Published Date" label-for="scheduledPublishedDate">
          <b-form-datepicker
            v-model="emailId.campaignDrafts[0].scheduledPublishedDate"
            id="scheduledPublishedDate"
            local="en"
            disabled
          />
        </b-form-group>
      </b-col>

      <b-col md="12">
        <b-form-group
          label="Email Content"
          label-for="email_content"
        ></b-form-group>
        <quill-editor v-model="emailId.emailTemplate.body" disabled />
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormInput,
  BFormTextarea,
  BFormSelect,
  BFormDatepicker,
  BFormGroup,
  BButton,
  BSpinner,
  BFormFile,
  BFormRadio,
} from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import flatPickr from "vue-flatpickr-component";

import { quillEditor } from "vue-quill-editor";
import {
  getProviderName,
  createProvider,
  deleteProvider,
  getProviders,
  testsmtp,
  updateProvider,
} from "@/store/smtp/services";


export default {
  name: "ViewCampaign",
  components: {
    BRow,
    BCol,
    BForm,
    BFormInput,
    BFormTextarea,
    BFormSelect,
    BFormDatepicker,
    BFormGroup,
    BButton,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    BFormFile,
    BFormRadio,
    vSelect,
    quillEditor,
    flatPickr,
  },

  data() {
    return {
      id: this.$route.params.id,
      mainLoading: false,
      emailtemplatelist: [],
      selectedTemplateId: null,
      selectedTemplate: [],
      segmentOptions: [],
      selectedSegments: [],
      emailTemplateOptions: [
        { value: "Template1", text: "Template 1" },
        { value: "Template2", text: "Template 2" },
        { value: "Template3", text: "Template 3" },
      ],
      statusOptions:[
        {value:"DRAFT",text:"DRAFT"},
        {value:"SCHEDULED",text:"SCHEDULED"},
        {value:"COMPLETED",text:"COMPLETED"},
        {value:"CANCELLED",text:"CANCELLED"}
      ],
      smtp: [],
      Selected: "A",
      Selected1: "c",
      SelectedRadio: "D",
      dateNtim: null,
      selected: [{ title: "Segment 1" }, { title: "Segment 2" }],
      content: `<h1>Quill Rich Text Editor</h1>
  <p>Quill is a free, <a href="https://github.com/quilljs/quill/">open source</a> WYSIWYG editor built for the modern web. With its <a href="http://quilljs.com/docs/modules/">modular architecture</a> and expressive <a href="http://quilljs.com/docs/api/">API</a>, it is completely customizable to fit any need.</p>
  <iframe class="ql-video" src="https://www.youtube.com/embed/QHH3iSeDBLo?showinfo=0" width="560" height="238"></iframe>
  <p><br></p>
  <h2>Getting Started is Easy</h2>
  <p><br></p>
  <pre>
// &lt;link href="https://cdn.quilljs.com/1.0.5/quill.snow.css" rel="stylesheet"&gt;
// &lt;script src="https://cdn.quilljs.com/1.0.5/quill.min.js" type="text/javascript"&gt;&lt;/script&gt;
  var quill = new Quill('#editor', {
  modules: {
  toolbar: '#toolbar'
  },
  theme: 'snow'
  });
// Open your browser's developer console to try out the API!</pre>  `,
    };
  },

  computed: {
    ...mapGetters("emailcampaign", {
      emailId: "emailcampaignid",
      loading: "loading",
    }),

    ...mapGetters("emailtemplate", {
      emailtemplate: "emailtemplate",
      loading: "loading",
    }),
    ...mapGetters("segmentModule", {
      segments: "segments",
      loading: "loading",
    }),
  },

  methods: {
    ...mapActions("emailcampaign", ["getEmailCampaignByIdAction"]),
    ...mapActions("segmentModule", ["getSegmentsAction"]),
    ...mapActions("emailtemplate", ["getEmailTemplateListAction"]),
    async fetchCampaignDetails() {
      this.mainLoading = true;
      try {
        await this.getEmailTemplateListAction().then(() => {
          this.emailtemplatelist = this.emailtemplate.map((template) => ({
            value: template.templateId,
            text: `${template.name}`,
          }));
        });

        await this.getSegmentsAction().then(() => {
          this.segmentOptions = this.segments.map((segment) => ({
            value: segment.segmentId,
            itemTitle: `${segment.name}`,
          }));
        });
        await this.getEmailCampaignByIdAction(this.id);
        this.selectedTemplateId = this.emailId.emailTemplate.templateId;
        this.selectedTemplate = this.emailtemplate.find(
          (template) => template.templateId === this.selectedTemplateId
        );
        // Set selected segments
        this.selectedSegments = this.emailId.segmentId
          .map((id) => {
            const segment = this.segments.find(
              (segment) => segment.segmentId === id
            );
            return segment
              ? { value: segment.segmentId, itemTitle: segment.name }
              : null;
          })
          .filter((segment) => segment !== null);
      } catch (error) {
        this.error(error);
      } finally {
        this.mainLoading = false;
      }
    },

    async getSMPT() {
      try {
        const response = await getProviders();
        this.smtp = response.data.result.map((smtp) => ({
          value: smtp.id,
          text: `${smtp.provider}`,
        }));
      } catch (error) {
        console.log(error);
      }
    },
  },
  async mounted() {
    await this.fetchCampaignDetails();
    await this.getSMPT();

  },
};
</script>

<style>
[dir] .dark-layout .vs--disabled .vs__dropdown-toggle,
[dir] .dark-layout .vs--disabled .vs__clear,
[dir] .dark-layout .vs--disabled .vs__search,
[dir] .dark-layout .vs--disabled .vs__selected,
[dir] .dark-layout .vs--disabled .vs__open-indicator {
  background-color: #28304685 !important;
}
[dir] .dark-layout .v-select:not(.vs--single) .vs__selected {
  background-color: rgb(155 219 13 / 23%) !important;
}
.dark-layout .v-select:not(.vs--single) .vs__selected {
  color: #a8f300fc !important;
}
.vs__selected {
  color: #6e6b7b !important;
  background-color: rgb(155 219 13 / 49%) !important;
}
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/quill.scss";
</style>
